import pdfFile from '../../assets/pdf/IF_Performance_Report.pdf';


export const Pdf3 = () => {

    return (
        <>
            <iframe
                src={pdfFile}
                style={{ width: '100%', height: '100vh' }}
            />
        </>
    )
}